import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_public/training-programs")({
  staticData: { title: "Training Programs" },
  component: () => <Outlet />,
});
